// extracted by mini-css-extract-plugin
export default {"purchaseIcon":"Nb4lkN"};